import { Link } from "react-router-dom";

export const Logo = ({ small = false }) => (
  <Link to="/" data-testid="site-logo-link" className="group flex shrink-0 items-center gap-2 select-none" aria-label="Tooth Buds home">
    <img src="/images/favicon.png" alt="" className={`${small ? "h-8" : "h-10"} rounded-xl bg-[#e0f2fe] p-0.5 transition-transform duration-300 group-hover:rotate-12`} />
    <span className={`font-display font-bold leading-none tracking-tight ${small ? "text-xl" : "text-2xl"}`}>
      <span className="text-[#38bdf8]">Tooth</span><span className="text-[#f5b82e]">Buds</span>
    </span>
  </Link>
);
